export const dashboardOptions = [
    { label: "Overview", value: "Overview" },
    { label: "⁠Invoice Dashboard", value: "⁠Invoice Dashboard" },
];